export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const PROTECTEDPAGE = "/protected";
export const FORMEQUIPO = "/formequipos";
export const PARTIDOS = "/partidos";
export const JUGADORES = "/jugadores/:id";
export const PERFIL = "/perfil";
export const EQUIPOS = "/equipos";
export const DETALLES = "/detalles/:id";
